import Vue from "vue";
import Component from "vue-class-component";
import { modalHelper, DataItem } from "@/components/modal/modalHelper";
import { Async } from "@/utils/AsyncDecorators";
import { Watch } from "vue-property-decorator";
import Form from "./form.vue";
import { areaBoscoDaSemeStore } from "../store/areaBoscoDaSeme.store";
import { applyArrayChanges } from "@/utils/ApplyArrayChange";
import { versioneInSituStore } from "@/modules/VersioneInSitu/store/VersioneInSitu.store";
import { areaOmogeneaStore } from "@/modules/AreeOmogenee/store/areaOmogenera.store";
import { store } from "@/store";
import autocomplete from "@/components/autocomplete/autocomplete.vue";
import { layoutHelper } from '@/helpers/LayoutHelper';
import { localVersionHelper } from '@/helpers/LocalVersionHelper';
import Display from './display.vue';
import { areaBoscoDaSemeService } from "../services/areaBoscoDaSemeService";
import { exportForm } from '../export';
import { usersStore } from "@/modules/Utenti/store/users.store";
import moment from "moment";
import { domainStore } from "@/modules/domains/store/domains.store";
import XLSX from "xlsx";
import { securityService } from "@/services/securityService";


Vue.component("area-bosco-da-seme-item", () => !layoutHelper.isWeb ? import("./mobile/areaBoscoDaSemeMobileItem.vue") : import("./web/areaBoscoDaSemeWebItem.vue"));

@Component({})
export default class Index extends Vue {
  showSearchBar: boolean = false;

  @Async({ async get() { return (await areaOmogeneaStore.getters.getAll()).sort((a, b) => a.nome.localeCompare(b.nome)); }, default: [], lazy: false })
  storeAreeOmogenee: server.areaOmogenea[];

  @Async({ async get() { return (await areaBoscoDaSemeStore.getters.getAll()).sort((a, b) => a.nome.localeCompare(b.nome)); }, default: [], lazy: true })
  areeBoscoDaSeme: server.areaBoscoDaSeme[];

  @Async({ async get() { return await versioneInSituStore.getters.current(); }, default: {}, lazy: false })
  currentVersion: server.VersioneInSitu;

  detailArray = [];
  downloading: boolean = false;
  datiCatastaliExcel: string = '';

  get utenteVisualizzatore(){
    return securityService.getInfo().roles.includes("Visualizzatore")
    && !securityService.getInfo().roles.includes("Amministratore")
    && !securityService.getInfo().roles.includes("Editore")
  }

  get areeOmogenee() {
    return this.storeAreeOmogenee.map((m) => {
      return {
        key: m.id,
        value: m.id,
        description: m.nome,
      } as server.autocomplete
    })
  }

  get navigation() {
    const areaOmogeneaId = store.getters.navigation.selected("areaOmogenea");
    if (!areaOmogeneaId) return null;
    return this.areeOmogenee.find(f => f.key === areaOmogeneaId) || {} as server.autocomplete;
  }

  set navigation(value: server.autocomplete) {
    store.actions.navigation.set_filter({ area: "areaOmogenea", id: value ? value.key : null });
  }

  filter = {
    text: "",
  };


  applyFilter(items: server.areaBoscoDaSeme[]): server.areaBoscoDaSeme[] {
    return items.filter(i => (!this.navigation?.key || i.areaOmogeneaId === this.navigation.key)
      && ((i.nome || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0
        || (i.provincia || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0
        || (i.comune || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0
        || (i.localita || "").toLowerCase().indexOf(this.filter.text.toLowerCase()) >= 0));
  }

  showsize: number = 20;
  @Watch("filter.text")
  changeFilterText(n, o) {
    this.showsize = 20;
  }

  get areeOrdered(): server.areaBoscoDaSeme[] {
    return this.applyFilter(this.areeBoscoDaSeme)
      .sort((a, b) => a.nome.localeCompare(b.nome))
      .slice(0, this.showsize);
  }

  selectedArea: server.areaBoscoDaSeme = null;
  async edit(item: server.areaBoscoDaSeme) {
    this.selectedArea = item;
    try {
      var result: DataItem<server.areaBoscoDaSeme>;
      if (localVersionHelper.get("InSitu")) {
        result = await modalHelper.showModal<server.areaBoscoDaSeme>(Display, Object.assign({}, item));
      } else {
        result = await modalHelper.showModal<server.areaBoscoDaSeme>(Form, Object.assign({}, item));
      }
      applyArrayChanges([result], this.areeBoscoDaSeme, (a, b) => a.id === b.id);
    } catch { }
    this.selectedArea = null;
  }

  async add() {
    try {
      const item: server.areaBoscoDaSeme = {
        versioneId: this.currentVersion.id, data: new Date(), datiCatastali: [], geoJSON: null, specieArboree: [], specieDiInteresse: [],
        areaOmogeneaId: store.getters.navigation.selected("areaOmogenea")
      } as server.areaBoscoDaSeme;
      const result: DataItem<server.areaBoscoDaSeme> = await modalHelper.showModal<server.areaBoscoDaSeme>(Form, Object.assign({}, item));
      applyArrayChanges([result], this.areeBoscoDaSeme, (a, b) => a.id === b.id);
    } catch { }
  }

  async showChild(item: server.areaBoscoDaSeme) {
    modalHelper.closeModal();
    store.actions.ui.toggleDrawerMenu(false);
    store.actions.ui.toggleUserMenu(false);
    await store.actions.navigation.set_filter({ area: "areaBoscoDaSeme", id: item.id } as server.navigation);
    this.$router.push({ name: "areeRaccolta" }).catch(err => { });
  }

  onShow() {
    return localVersionHelper.get("InSitu") ? true : false
  }

  async exporting() {
    this.downloading = true;
    this.detailArray = [];
    for (const element of this.areeBoscoDaSeme) {
      var detail: server.areaBoscoDaSeme = null;
        detail = await areaBoscoDaSemeService.Detail(element.id, element.versioneId);
        await this.exportSingleForm(detail);
    };
    this.printSchedaExcel('Aree-boschi-da-seme', this.detailArray, '', null)
  }

  async exportSingleForm(source: server.areaBoscoDaSeme): Promise<void> {
    this.datiCatastaliExcel = '';
    let utenteCreatore: string = "-- nessun creatore --";
    let utentiRilevatori: string = "-- nessun rilevatore --";
    const users = await usersStore.getters.getAll();

    if (source.userId) {
      const user = users.find(f => f.id.toLowerCase() === source.userId.toLowerCase());
      if (user) utenteCreatore = `${user.firstName} ${user.lastName}`;
    }

    if ((source.utentiRilevatori || []).length > 0) {
      utentiRilevatori = users.filter(f => source.utentiRilevatori.map(m => m.toLowerCase()).indexOf(f.id.toLowerCase()) !== -1)
        .map((m) => `${m.firstName} ${m.lastName}`)
        .sort((a, b) => a.localeCompare(b)).toString();
    }



    const printObj =
    {
      'Anno censimento': (await versioneInSituStore.getters.get(source.versioneId)).alias,
      'Denominazione Area': source.nome ? source.nome : '',
      'Area omogenea relazionata': (await areaOmogeneaStore.getters.get(source.areaOmogeneaId)).nome,
      'Proprietà Dati Generali': source.proprieta ? source.proprieta : '',
      'Note': source.note ? source.note : null,
      'Data rilievo': source.data ? moment(source.data).format("DD-MM-YYYY") : '',
      'Utente creatore dell\'area': utenteCreatore,
      'Rilevatori in campo': utentiRilevatori,
      // 'Dati catastali': source.datiCatastali ? this.datiCatastaliExcel: '',
      'Denominazione provenienza': source.provenienza ? source.provenienza : '',
      'Località': source.localita ? source.localita : '',
      'Bacino idrografico': source.bacinoIdrografico ? source.bacinoIdrografico : '',
      'Provincia': source.provincia ? source.provincia : '',
      'Comune': source.comune ? source.comune : '',
      'Stazione CCF': source.stazioneCCF ? source.stazioneCCF : '',
      'Riferimenti cartografici': source.riferimentiCartografici ? source.riferimentiCartografici : '',
      'Superficie Bosco': source.superficieBosco || source.superficieBosco == 0 ? source.superficieBosco + ' m2' : '',
      'Superficie Area': source.area || source.area == 0 ? source.area.toFixed(2) + ' m2' : '',
      'Altitudine': source.altitudine || source.altitudine == 0 ? source.altitudine.toFixed(1) + ' m' : '',
      'Altezza dal fondovalle': source.altezzaFondovalle || source.altezzaFondovalle == 0 ? source.altezzaFondovalle.toFixed(1) + ' m' : '',
      'Giacitura': source.giacitura != null && source.giacitura != undefined ? (await domainStore.getters.giacitura(source.giacitura))?.label : '',
      'Esposizione': source.esposizione != null && source.esposizione != undefined ? (await domainStore.getters.esposizione(source.esposizione))?.label : '',
      'Pietrosità': source.pietrosita != null && source.pietrosita != undefined ? (await domainStore.getters.pietrositaByValue(source.pietrosita))?.label : '',
      'Pendenza': source.pendenza || source.pendenza == 0 ? source.pendenza : '',
      'Aff. rocciosi': source.rocciosi || source.rocciosi == 0 ? source.rocciosi : '',
      'Note informazioni geografiche': source.altreInformazioniGeografiche ? source.altreInformazioniGeografiche : null,
      'Stazione termometrica di riferimento': source.stazioneTermometrica ? source.stazioneTermometrica : '',
      'T media annua': source.temperaturaAnnuaMedia || source.temperaturaAnnuaMedia == 0 ? source.temperaturaAnnuaMedia + ' °C' : '',
      'T media mese più caldo': source.temperaturaMensileMeseCaldoMedia || source.temperaturaMensileMeseCaldoMedia == 0 ? source.temperaturaMensileMeseCaldoMedia + ' °C' : '',
      'T media mese più freddo': source.temperaturaMensileMeseFreddoMedia || source.temperaturaMensileMeseFreddoMedia == 0 ? source.temperaturaMensileMeseFreddoMedia + ' °C' : '',
      'T max assoluta': source.temperaturaAssolutaMax || source.temperaturaAssolutaMax == 0 ? source.temperaturaAssolutaMax + ' °C' : '',
      'T min assoluta': source.temperaturaAssolutaMin || source.temperaturaAssolutaMin == 0 ? source.temperaturaAssolutaMin + ' °C' : '',
      'Stazione pluviometrica di riferimento': source.stazionePluviometrica ? source.stazionePluviometrica : '',
      'Precipitazioni annue': source.precipitazioniAnnue || source.precipitazioniAnnue == 0 ? source.precipitazioniAnnue + ' mm' : '',
      'Precipitazioni estive [Giu-Set]': source.precipitazioniEstive || source.precipitazioniEstive == 0 ? source.precipitazioniEstive + ' mm' : '',
      'Venti dominanti': source.ventiDominanti ? source.ventiDominanti : '',
      'N° giorni piovosi': source.numeroGiorniPiovosi || source.numeroGiorniPiovosi == 0 ? source.numeroGiorniPiovosi : '',
      'N° giorni piovosi estivi': source.numeroGiorniPiovosiEstivi || source.numeroGiorniPiovosiEstivi == 0 ? source.numeroGiorniPiovosiEstivi : '',
      'Altre informazioni climatiche (neve, grandine, gealte, nebbie...)': source.altreInformazioniClimatiche ? source.altreInformazioniClimatiche : '',
      'Substrato Pedogenetico': source.substratoPedogenetico != null && source.substratoPedogenetico != undefined ? (await domainStore.getters.substratoPetrogenico(source.substratoPedogenetico))?.label : '',
      'Profondità terreno': source.profonditaTerreno || source.profonditaTerreno == 0 ? source.profonditaTerreno + ' cm' : '',
      'Orizzonti presenti': source.orizzontiPresenti ? source.orizzontiPresenti : '',
      'Lettiera': source.lettiera != null && source.lettiera != undefined ? (await domainStore.getters.lettiera(source.lettiera))?.label : '',
      'Note geopedologia': source.altreInformazioniGeopedologiche ? source.altreInformazioniGeopedologiche : null,
      'Origine': source.originePopolamentoForestale != null && source.originePopolamentoForestale != undefined ? (await domainStore.getters.originePopolamentoForestale(source.originePopolamentoForestale))?.label : '',
      'Governo': source.governo != null && source.governo != undefined ? (await domainStore.getters.governo(source.governo))?.label : '',
      'Trattamento': source.trattamento != null && source.trattamento != undefined ? (await domainStore.getters.trattamento(source.trattamento))?.label : '',
      'Stadio evolutivo': source.stadioEvolutivo ? source.stadioEvolutivo : '',
      'Età': source.eta ? source.eta : '',
      'Struttura Verticale': source.strutturaVerticale != null && source.strutturaVerticale != undefined ? (await domainStore.getters.strutturaVerticale(source.strutturaVerticale))?.label : '',
      'Struttura Orizzontale Tessitura': source.strutturaOrizzontaleTessitura != null && source.strutturaOrizzontaleTessitura != undefined ? (await domainStore.getters.strutturaOrizzontale(source.strutturaOrizzontaleTessitura))?.label : '',
      'Note struttura forestale': source.altreInformazioniPopolamentoForestale ? source.altreInformazioniPopolamentoForestale : null,
      'Composizione Specifica': source.specificaComposizioneVegetazionaleId != null && source.specificaComposizioneVegetazionaleId != undefined ? (await domainStore.getters.composizioneVegetazionale(source.specificaComposizioneVegetazionaleId))?.label : '',
      'Specie arboree': source.specieArboree != null && source.specieArboree.length > 0 ? (await domainStore.getters.specieArboree()).filter((f) => source.specieArboree.includes(f.id)).map((m) => m?.label).join(", ") : '',
      'Specie arbustiva': source.specieArbustive ? source.specieArbustive : '',
      'Specie erbacee': source.specieErbacee ? source.specieErbacee : '',
      'Note vegetazione': source.altreInformazioniVegetazionali ? source.altreInformazioniVegetazionali : null,
      'Specie di interesse': source.specieDiInteresse != null && source.specieDiInteresse.length > 0 ? (await domainStore.getters.specieArboree()).filter((f) => source.specieDiInteresse.includes(f.id)).map((m) => m?.label).join(", ") : '',
      'Origine Materiale Selezionato ': source.origineMaterialeSelezionato != null && source.origineMaterialeSelezionato != undefined ? (await domainStore.getters.origineMaterialeSelezionato(source.origineMaterialeSelezionato))?.label : '',
      'Isolamento': source.isolamento ? source.isolamento : '',
      'Entità della popolazione': source.popolazione ? source.popolazione : '',
      'Età e sviluppo': source.etaESviluppo ? source.etaESviluppo : '',
      'Omogeneità': source.omogeneita ? source.omogeneita : '',
      'Adeguetezza': source.adeguatezza ? source.adeguatezza : '',
      'Stato sanitario': source.statoSanitario ? source.statoSanitario : '',
      'Qualità del legno': source.qualitaLegno ? source.qualitaLegno : '',
      'Forma o portamento': source.formaPortamento ? source.formaPortamento : '',
      'Accessibilità': source.accessibilita ? source.accessibilita : '',
      'Proprietà': source.proprietaCarattereGenerale ? source.proprietaCarattereGenerale : '',
    };

    if((source.datiCatastali || []).length > 0) {
      source.datiCatastali.forEach((element, idx) => {
        var d = {};
        for (const key in element) {
          if (Object.prototype.hasOwnProperty.call(element, key)) {
            d[`Dati Catastali ${key}-${idx+1}`] = element[key];
          }
        }
        Object.assign(printObj, d);
      });
    }
    this.detailArray.push(printObj);
  }

  public printSchedaExcel(title: string, datas: Array<any>, sheetName: string, heading: string[] = null) {
    var arrayData = Object.assign([], datas);
    const wb = XLSX.utils.book_new();
    wb.Props = {
      Title: title,
      CreatedDate: new Date()
    }

    if (!sheetName) {
      sheetName = title;
    }

    let date = moment(new Date())
    wb.SheetNames.push(sheetName);
    if (heading && heading.length > 0) {
      var ws = XLSX.utils.aoa_to_sheet([heading]);
      XLSX.utils.sheet_add_json(ws, arrayData, { header: heading, origin: { r: 1, c: -(heading.length) }, skipHeader: true });
    }
    else {
      var ws = XLSX.utils.json_to_sheet(arrayData);
    }
    wb.Sheets[sheetName] = ws;
    XLSX.writeFile(wb, `${title.toLowerCase()}_${date.format("YYYYMMDDHHmm")}.xlsx`);
    this.downloading = false;
  }

}